export const DASHBOARD_LABELS = {
	WEB_DASHBOARD_TITLE: 'Web Dashboard',
	MOBILE_DASHBOARD_TITLE: 'Mobile Dashboard',
	MOBILE_DASHBOARD_INFO_BANNER:
		'This dashboard shows aggregated data from the Mobile Flow Analyzer and Mobile SDKs only.',
	ACCESSIBILITY_PERFORMANCE_TRENDS: 'Accessibility performance trends',
	BUSINESS_UNITS: 'Business Units',
	LAST_UPDATED: 'Last updated',
	BACK: 'Back',
	DASHBOARD_TABS_ARIA_LABEL: 'Dashboard tabs',
	MOBILE_FLOW_ANALYZER_TAB: 'Mobile Flow Analyzer',
	MOBILE_SDKS_TAB: 'Mobile SDKs',
	MFA_SESSION_NAME_LABEL: 'Session name',
	MOBILE_SDK_TEST_NAME_LABEL: 'Test name',
	ALL_ISSUES_TAB: 'All issues',
	UNIQUE_ISSUES_TAB: 'Unique issues',
	ALL_ISSUES_TABLE_TITLE: 'All Issues',
	UNIQUE_ISSUES_TABLE_TITLE: 'Unique Issues',
	ALL_ISSUES_TABLE_ARIA_LABEL: 'All Issues Table',
	UNIQUE_ISSUES_TABLE_ARIA_LABEL: 'Unique Issues Table',
	ALL_ISSUES_LOAD_ERROR: 'Failed to load all issues. Please try again.',
	UNIQUE_ISSUES_LOAD_ERROR: 'Failed to load unique issues. Please try again.'
};
